export default "__VITE_ASSET__BvIQdmQf__"